import { render, staticRenderFns } from "./CartSectionProductDetail.vue?vue&type=template&id=72dd634f&scoped=true"
import script from "./CartSectionProductDetail.vue?vue&type=script&lang=js"
export * from "./CartSectionProductDetail.vue?vue&type=script&lang=js"
import style0 from "./CartSectionProductDetail.vue?vue&type=style&index=0&id=72dd634f&prod&lang=css"
import style1 from "./CartSectionProductDetail.vue?vue&type=style&index=1&id=72dd634f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dd634f",
  null
  
)

export default component.exports